import React, { useImperativeHandle, useState, forwardRef } from 'react'
import Button from '@material-ui/core/Button'

function Question(props, ref) {
    const [state, setState] = useState({
        modal: false,
        overlay: false,
        data: {}
    })

    useImperativeHandle(ref, () => ({
        open: data => handleOpen(data),
        close: () => handleClose()
    }))

    const handleOpen = data => {
        setState(prev => ({
            ...prev,
            overlay: true,
            data
        }))
        setTimeout(() => {
            setState(prev => ({
                ...prev,
                modal: true
            }))
        }, 100)
    }

    const handleClose = () => {
        setState(prev => ({
            ...prev,
            modal: false
        }))
        setTimeout(() => {
            setState(prev => ({
                ...prev,
                overlay: false,
                data: {}
            }))
        }, 50)
    }

    const handleAccept = () => {
        props.acceptCallback && props.acceptCallback(false)
        props.handleConfirm && props.handleConfirm(state.data)
        handleClose()
    }
    const handleCancel = () => {
        props.cancelCallback && props.cancelCallback(false)
        handleClose()
    }
    return (
        <div id="overlay" className={props.blur || state.overlay ? 'visible' : ''}>
            <div className={`box question ${props.popup || state.modal ? 'show' : ''}`}>
                <h3 style={{ padding: '0 100px' }}>
                    {props.mainMessage}
                </h3>
                <p>
                    {props.secondaryMessage}
                </p>
                <div className="buttons">
                    <Button className="cancel-request" onClick={handleCancel}>
                        Отказ
                    </Button>
                    <Button className="accept-request" onClick={handleAccept}>
                        {props.rename ? props.rename : 'ОК'}
                    </Button>
                </div>
            </div>
        </div >
    )
}

export default forwardRef(Question)